import Layout from "../../components/Layout/Layout";
import ApplicationList from "../../components/ApplicationList/ApplicationList";
import { useNavigate } from "react-router-dom";
import { LAYOUT_TYPE } from "../../constants";

export default function Applications() {
  const navigate = useNavigate();

  return (
    <Layout
      type={LAYOUT_TYPE.INITIAL_PAGE}
      title="Applications"
      buttons={[
        {
          title: "Add Application",
          variant: "primary",
          action: () => {
            navigate("/application/create");
          },
        },
      ]}
    >
      <ApplicationList />
    </Layout>
  );
}
